import React from "react";
import { Bubble } from "react-chartjs-2";
import EnsaConstant from "../../../pages/Reports/ensa/EnsaConstant";
import { Chart } from "chart.js";

const ChartBublePosSekolah = (params) => {
    let listData = params.dataProgres;
    const options = {
        plugins: {
            legend: {
                labels: {
                    filter: function (legendItem) { 
                        return legendItem.text !== null;
                    },
                },
            },
        },
    };

    function getDataChart(param, isOuline) {
        let result = []
        let listPosisiSekolah = isOuline ? listData.outer : listData.nonOuter
        for (let i in listPosisiSekolah) {
            const data = listPosisiSekolah[i]
            if (data.key == param) {
                const newData = new Object()
                newData.x = i + 1
                newData.y = data.skor
                newData.r = 5
                result.push(newData)
            }
        }
        return result;
    }

    function getDataSetNonOuter() {
        let result = []
        for (let i in listData.title) {
            const item = listData.title[i]
            const data = new Object()
            data.label = item.key
            data.backgroundColor = item.color
            data.hoverBackgroundColor = "#FFFFFF"
            data.hoverBorderColor = item.color
            data.hoverBorderWidth = 5
            data.hoverRadius = 5
            data.data = getDataChart(item.key, false)
            result.push(data)
        }
        return result
    }

    function getDataSetOuter() {
        let result = []
        for (let i in listData.title) {
            const item = listData.title[i]
            const data = new Object()
            data.label = null
            data.backgroundColor = item.color
            data.borderColor = "black"
            data.borderWidth = 2
            data.hoverBackgroundColor = "#FFFFFF"
            data.hoverBorderColor = item.color
            data.hoverBorderWidth = 5
            data.hoverRadius = 5
            data.data = getDataChart(item.key, true)
            result.push(data)
        }
        return result
    }

    function mergeData() {
        let listOuter = getDataSetOuter()
        let listNonOuter = getDataSetNonOuter()
        return [...listNonOuter, ...listOuter]
    }

    const data = {
        datasets: mergeData()
    };

    return (
        <div style={{ width: "100%" }}>
            <Bubble
                data={data}
                options={options}
                // plugins={[plugins]}
                width={900}
                height={275}
            />
        </div>
    );
};

export default ChartBublePosSekolah;
